export default __webpack_public_path__ + "static/7-35de54d27f0a8eb2028e9f316a813f8c.png";